/* Ability Warehouse — right-hand slide-out cart.
   Speed: every cart change is ONE Ajax request that also returns the re-rendered drawer (and the cart page section on /cart)
   through the `sections` parameter, so nothing is fetched twice and the cart page never reloads. Cart writes run one at a
   time (queue) so responses always render in order. The membership tick updates the total instantly, then confirms. */
(function () {
  'use strict';
  var wrap = document.querySelector('[data-cart-drawer]');
  if (!wrap) return;
  var panel = wrap.querySelector('.cd__panel');
  var lastFocus = null;
  var SECTION = '/cart?section_id=cart-drawer';
  var cartSecWrap = document.querySelector('section.cart') && document.querySelector('section.cart').closest('.shopify-section');
  var CART_SEC = cartSecWrap ? cartSecWrap.id.replace('shopify-section-', '') : '';
  function sectionsParam() { return CART_SEC ? 'cart-drawer,' + CART_SEC : 'cart-drawer'; }

  var chain = Promise.resolve();
  function enqueue(fn) { var p = chain.then(fn, fn); chain = p.catch(function () {}); return p; }

  function inner() { return wrap.querySelector('[data-cd-inner]'); }
  function cartPage() { return document.querySelector('section.cart'); }
  function setCount(n) {
    document.querySelectorAll('.header__cart').forEach(function (a) {
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
      var c = a.querySelector('.header__count');
      if (n > 0) {
        if (!c) { c = document.createElement('span'); c.className = 'header__count'; a.appendChild(c); }
        c.textContent = n;
        c.classList.remove('is-bump'); void c.offsetWidth; c.classList.add('is-bump');
      } else if (c) c.remove();
    });
  }
  /* `text` is HTML: callers pass only their own markup or values run through esc() */
  function msg(text, type) {
    var m = wrap.querySelector('[data-cd-msg]');
    if (m) { m.className = 'cd__msg' + (type ? ' cd__msg--' + type : ''); m.innerHTML = text || ''; }
    var cp = cartPage();
    if (cp && type === 'error') {
      var e = cp.querySelector('[data-cart-err]');
      if (!e) { e = document.createElement('p'); e.className = 'cart__err'; e.setAttribute('role', 'alert'); e.setAttribute('data-cart-err', ''); cp.insertBefore(e, cp.firstChild.nextSibling); }
      e.textContent = String(text).replace(/<[^>]+>/g, '').replace(/&lt;/g, '<').replace(/&gt;/g, '>').replace(/&quot;/g, '"').replace(/&#39;/g, "'").replace(/&amp;/g, '&');
    }
  }
  function busy(on) {
    wrap.classList.toggle('is-busy', on);
    var cp = cartPage(); if (cp) cp.classList.toggle('is-busy', on);
  }

  /* ---------- rendering from section HTML ---------- */
  var dropping = null, dropTries = 0, isFresh = false, prefetching = null;
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }
  function renderDrawer(html) {
    var fresh = parse(html).querySelector('[data-cd-inner]');
    if (!fresh) return Promise.resolve();
    inner().replaceWith(fresh);
    setCount(parseInt(fresh.dataset.count, 10) || 0);
    isFresh = true;
    if (fresh.hasAttribute('data-cd-drop-mem') && dropTries++ < 2) return dropMembership();
    return Promise.resolve();
  }
  function renderCartPage(html) {
    var fresh = parse(html).querySelector('section.cart'), cur = cartPage();
    if (!fresh || !cur) return;
    cur.replaceWith(fresh);
    initNdis();
    if (fresh.hasAttribute('data-cd-drop-mem') && dropTries++ < 2) dropMembership();
  }
  function apply(sections) {
    if (!sections) return Promise.resolve();
    if (CART_SEC && sections[CART_SEC]) renderCartPage(sections[CART_SEC]);
    return sections['cart-drawer'] ? renderDrawer(sections['cart-drawer']) : Promise.resolve();
  }
  function refresh() {
    return fetch(SECTION, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(renderDrawer);
  }

  /* ---------- open / close ---------- */
  function open() {
    lastFocus = document.activeElement;
    wrap.hidden = false;
    void panel.offsetWidth;
    wrap.classList.add('is-open');
    document.body.classList.add('no-scroll');
    setTimeout(function () { panel.focus(); }, 30);
  }
  /* Open instantly with what we already have, then refresh quietly in the background */
  function openNow() {
    open();
    if (!isFresh) { wrap.classList.add('is-busy'); (prefetching || refresh()).then(function () { isFresh = true; }).catch(function () {}).then(function () { wrap.classList.remove('is-busy'); }); }
  }
  function prefetch() { if (!isFresh && !prefetching) prefetching = refresh().then(function () { isFresh = true; }).catch(function () {}).then(function () { prefetching = null; }); }
  ['pointerenter', 'pointerdown', 'touchstart', 'focusin'].forEach(function (ev) {
    document.addEventListener(ev, function (e) { if (e.target.closest && e.target.closest('.header__cart, [data-cart-open]')) prefetch(); }, { passive: true, capture: true });
  });
  function close() {
    wrap.classList.remove('is-open');
    document.body.classList.remove('no-scroll');
    setTimeout(function () { wrap.hidden = true; }, 200);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* ---------- Ajax helpers ---------- */
  function cartJson() { return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); }); }
  function postJson(url, body) {
    return fetch(url, { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) })
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw new Error(j.description || j.message || 'Could not update your cart.'); return j; }); });
  }
  function membershipLines(cart) { return (cart.items || []).filter(function (i) { return i.handle === 'membership'; }); }

  /* One request: change a line and get the new drawer/cart page back */
  function change(key, qty) {
    busy(true);
    return enqueue(function () {
      return postJson('/cart/change.js', { id: String(key), quantity: qty, sections: sectionsParam() }).then(function (j) { return apply(j.sections); });
    }).catch(function (err) { msg(esc(err.message || 'Could not update your cart. Please try again.'), 'error'); return refresh().catch(function () {}); })
      .then(function () { busy(false); });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('.header__cart, [data-cart-open]');
    if (a && !/^\/cart\/?$/.test(location.pathname)) { e.preventDefault(); openNow(); return; }
    if (e.target.closest('[data-cd-close]')) { close(); return; }
    var q = e.target.closest('[data-cd-qty]');
    if (q) change(q.dataset.cdQty, parseInt(q.dataset.q, 10));
  });
  wrap.addEventListener('change', function (e) {
    var i = e.target.closest('[data-cd-input]');
    if (i) change(i.dataset.cdInput, Math.max(0, parseInt(i.value, 10) || 0));
  });
  /* Cart page quantity / remove: same one-request path instead of a full page load */
  document.addEventListener('click', function (e) {
    var a = e.target.closest('section.cart a.qty__btn, section.cart a.line__remove'); if (!a) return;
    var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
    var id = u.searchParams.get('id'), q = parseInt(u.searchParams.get('quantity'), 10);
    if (!id || isNaN(q)) return;
    e.preventDefault(); e.stopImmediatePropagation();
    change(id, Math.max(0, q));
  }, true);
  document.addEventListener('change', function (e) {
    var i = e.target.closest && e.target.closest('section.cart [data-autosubmit]'); if (!i) return;
    var lk = i.parentNode && i.parentNode.querySelector('a.qty__btn'), key = '';
    try { key = new URL(lk.href, location.href).searchParams.get('id'); } catch (err) { return; }
    if (!key) return;
    e.stopImmediatePropagation();
    change(key, Math.max(0, parseInt(i.value, 10) || 0));
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && wrap.classList.contains('is-open')) close();
    if (e.key === 'Tab' && wrap.classList.contains('is-open')) {
      var f = panel.querySelectorAll('a[href], button:not([disabled]), input, [tabindex="0"]');
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  });

  /* ---------- Membership bar (drawer + cart page): ticked <=> the monthly membership is in the cart ----------
     On:  one /cart/add.js (returns the new drawer) — then the new-member code is attached to the cart in the background.
     Off: one /cart/update.js that removes the membership line(s) and clears the code, returning the new drawer.
     The Checkout links always carry the matching code, so checkout matches the cart even if the background step is still running. */
  function setMembership(on, bar, canApply) {
    var ok = function (j) { return (!canApply || canApply()) ? apply(j.sections) : null; };
    var d = bar.dataset, code = d.code || 'NEWMEMBER';
    if (on) {
      var item = { id: +d.mv, quantity: 1, properties: { Promo: d.freeMonth === 'true' ? '2 months free membership' : 'First month free' } };
      if (+d.plan) item.selling_plan = +d.plan;
      return postJson('/cart/add.js', { items: [item], sections: sectionsParam() })
        .then(ok)
        .then(function () { enqueue(function () { return postJson('/cart/update.js', { discount: code, sections: sectionsParam() }).then(function (j) { return apply(j.sections); }).catch(function () {}); }); });
    }
    var keys = ((inner() && inner().dataset.mkeys) || d.keys || '').split(',').filter(Boolean);
    return (keys.length ? Promise.resolve(keys) : cartJson().then(function (c) { return membershipLines(c).map(function (l) { return l.key; }); }))
      .then(function (ks) {
        var updates = {}; ks.forEach(function (k) { updates[k] = 0; });
        return postJson('/cart/update.js', { updates: updates, discount: '', sections: sectionsParam() });
      })
      .then(ok);
  }
  /* Every product line is no-sale (DearJane): no bar, so a membership left in the cart is removed and no member code applies */
  function dropMembership() {
    if (dropping) return dropping;
    dropping = cartJson().then(function (cart) {
      var lines = membershipLines(cart); if (!lines.length) return 0;
      var updates = {}; lines.forEach(function (l) { updates[l.key] = 0; });
      return postJson('/cart/update.js', { updates: updates, discount: '', sections: sectionsParam() })
        .then(function (j) { dropping = null; return apply(j.sections); }).then(function () { return lines.length; });
    }).catch(function () { return 0; }).then(function (n) { dropping = null; return n; });
    return dropping;
  }
  if ((cartPage() && cartPage().hasAttribute('data-cd-drop-mem')) || (inner() && inner().hasAttribute('data-cd-drop-mem'))) { dropTries++; dropMembership(); }

  /* Every total in scope (drawer total; cart page summary + sticky checkout bar) */
  function paintTotal(scope, on) {
    if (!scope) return;
    Array.prototype.forEach.call(scope.querySelectorAll('[data-totp]'), function (tp) {
      var full = tp.dataset.full, mem = tp.dataset.mem;
      tp.innerHTML = on && mem && mem !== full ? '<s class="num">' + full + '</s><b class="num is-mem">' + mem + '</b>' : '<b class="num">' + full + '</b>';
    });
  }
  function paintBar(bar, on) {
    bar.classList.toggle('off', !on);
    var cap = bar.querySelector('[data-mt-cap]'); if (cap) cap.textContent = on ? '✓ Applied' : 'Tick to';
    var chk = bar.querySelector('[data-mt-chk]'); if (chk) chk.checked = on;
    var scope = bar.closest('[data-cd-inner]') || bar.closest('section.cart');
    paintTotal(scope, on);
    /* Checkout links follow the tick straight away (NEWMEMBER with membership, NOMEMBER without) */
    var code = bar.dataset.code || 'NEWMEMBER';
    if (scope) Array.prototype.forEach.call(scope.querySelectorAll('a[href*="/discount/"]'), function (a) {
      a.href = a.getAttribute('href').replace(/\/discount\/(NEWMEMBER|NOMEMBER|[^/?]+)(?=\?)/, function (m, c) { return (c === code || c === 'NOMEMBER') ? '/discount/' + (on ? code : 'NOMEMBER') : m; });
    });
  }
  document.addEventListener('change', function (e) {
    var chk = e.target.closest('[data-mt-chk]'); if (!chk) return;
    var bar = chk.closest('[data-mt]'), on = chk.checked;
    paintBar(bar, on); /* instant: tick, totals and Checkout links */
    memWant = on;
    if (!memRun) memRun = runMem(bar);
  });
  /* Shopify's cart takes ~2 s to add/remove the membership. The page doesn't wait: the latest tick wins, rapid
     toggles collapse into one request, and the re-rendered drawer is only applied once no newer tick is waiting. */
  var memWant = null, memRun = null;
  function curBar(b) { return (b && document.contains(b)) ? b : (document.querySelector('section.cart [data-mt]') || document.querySelector('[data-cart-drawer] [data-mt]') || b); }
  function runMem(bar) {
    var want = memWant; memWant = null;
    return enqueue(function () { return setMembership(want, curBar(bar), function () { return memWant === null; }); })
      .catch(function (err) {
        if (memWant === null) { var b = curBar(bar); if (b) paintBar(b, !want); }
        msg(esc(err.message || 'Could not update your cart. Please try again.'), 'error');
      })
      .then(function () { if (memWant !== null) return runMem(bar); memRun = null; });
  }
  document.addEventListener('click', function (e) {
    if (!memRun) return;
    var a = e.target.closest('a[href*="/discount/"]'); if (!a) return;
    e.preventDefault();
    var label = a.textContent; a.textContent = 'Updating…'; a.setAttribute('aria-busy', 'true');
    memRun.then(function () { location.href = a.href; }, function () { a.textContent = label; a.removeAttribute('aria-busy'); });
  }, true);

  /* ---------- "How it works" popup: the product page has its own modal (pdp.js); elsewhere use the drawer's ---------- */
  var cdm = document.querySelector('[data-cd-mem-modal]'), cdmBody = cdm && cdm.querySelector('[data-cd-mem-body]'), cdmLoaded = false, cdmFocus = null;
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (ch) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[ch]; }); }
  function loadCdm() {
    if (cdmLoaded) return; cdmLoaded = true;
    var src = cdmBody.dataset.src || '/pages/membership';
    fetch(src, { credentials: 'same-origin' }).then(function (r) { if (!r.ok) throw new Error(r.status); return r.text(); }).then(function (html) {
      var doc = new DOMParser().parseFromString(html, 'text/html');
      var mem = doc.querySelector('[data-mem]'); if (!mem) throw new Error('no section');
      var wrapEl = mem.closest('.shopify-section') || mem.parentNode;
      Array.prototype.slice.call(wrapEl.querySelectorAll('[data-mem-bar]')).forEach(function (b) { b.remove(); });
      Array.prototype.slice.call(wrapEl.querySelectorAll('h1')).forEach(function (h) { var h2 = doc.createElement('h2'); h2.className = h.className; h2.innerHTML = h.innerHTML; h.replaceWith(h2); });
      var scripts = Array.prototype.slice.call(wrapEl.querySelectorAll('script')).map(function (s) { var t = s.textContent; s.remove(); return t; });
      cdmBody.innerHTML = '';
      Array.prototype.slice.call(wrapEl.childNodes).forEach(function (n) { cdmBody.appendChild(document.importNode(n, true)); });
      scripts.forEach(function (t) { var s = document.createElement('script'); s.textContent = t; cdmBody.appendChild(s); });
    }).catch(function () { cdmLoaded = false; cdmBody.innerHTML = '<p class="cdm__msg">We could not load the details here. <a href="' + esc(src) + '">Open the membership page</a>.</p>'; });
  }
  if (cdm && cdmBody && typeof cdm.showModal === 'function') {
    cdm.addEventListener('close', function () { document.documentElement.classList.remove('cdm-open'); if (cdmFocus && cdmFocus.focus) cdmFocus.focus(); });
    cdm.addEventListener('click', function (e) { if (e.target === cdm) cdm.close(); });
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-cd-mem-close]')) { if (cdm.open) cdm.close(); return; }
      var o = e.target.closest('[data-mem-open]'); if (!o) return;
      if (document.querySelector('[data-pdp] [data-mem-modal]')) return; /* pdp.js opens its own */
      e.preventDefault(); e.stopPropagation();
      cdmFocus = document.activeElement; loadCdm(); cdm.showModal(); document.documentElement.classList.add('cdm-open');
      var x = cdm.querySelector('[data-cd-mem-close]'); if (x) x.focus();
    });
  }

  /* ---------- Cart page: "How are you paying?" saved as cart attributes (re-bound after the section re-renders) ---------- */
  function initNdis() {
    var ndis = document.querySelector('[data-ndis]');
    if (!ndis || ndis.dataset.bound) return;
    ndis.dataset.bound = '1';
    var ndisTimer;
    var val = function (sel) { var r = ndis.querySelector(sel + ':checked'); return r ? r.value : ''; };
    var syncNdis = function () {
      var funds = /NDIS/.test(val('[data-ndis-pay]')), plan = val('[data-ndis-who]') === 'Plan-managed';
      var f = ndis.querySelector('[data-ndis-funds]'); if (f) f.hidden = !funds;
      var pm = ndis.querySelector('[data-ndis-pm]'); if (pm) pm.hidden = !plan;
      Array.prototype.slice.call(ndis.querySelectorAll('.copt')).forEach(function (o) { var i = o.querySelector('input'); o.classList.toggle('on', !!(i && i.checked)); });
    };
    var saveNdis = function () {
      var pay = val('[data-ndis-pay]') || 'Pay now', funds = /NDIS/.test(pay), who = funds ? val('[data-ndis-who]') : '', plan = who === 'Plan-managed';
      var attrs = { 'Payment': pay, 'Managed by': who };
      Array.prototype.slice.call(ndis.querySelectorAll('[data-ndis-attr]')).forEach(function (i) {
        var k = i.getAttribute('data-ndis-attr');
        attrs[k] = funds && !(k.indexOf('Plan manager') === 0 && !plan) ? i.value.trim() : '';
      });
      var m = ndis.querySelector('[data-ndis-saved]');
      enqueue(function () {
        return fetch('/cart/update.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ attributes: attrs }) })
          .then(function (r) { if (m) m.textContent = r.ok ? (funds ? 'Saved to your order.' : '') : 'Could not save. Please try again.'; })
          .catch(function () { if (m) m.textContent = 'Could not save. Please try again.'; });
      });
    };
    ndis.addEventListener('change', function () { syncNdis(); clearTimeout(ndisTimer); ndisTimer = setTimeout(saveNdis, 200); });
    ndis.addEventListener('input', function (e) { if (!e.target.matches('[data-ndis-attr]')) return; clearTimeout(ndisTimer); ndisTimer = setTimeout(saveNdis, 600); });
    syncNdis();
  }
  initNdis();


  /* Product page, guest with the membership box ticked: product + membership in ONE /cart/add.js that also returns the
     new drawer (no /cart.js check, no /discount round-trip). Runs in the capture phase, before pdp.js's handler. */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-pdp] form[data-calc]')) return;
    var root = form.closest('[data-pdp]'), tog = root.querySelector('[data-tog-input]');
    if (!tog || !tog.checked || root.dataset.noSale === 'true' || root.dataset.locked === 'true') return;
    e.preventDefault(); e.stopImmediatePropagation();
    var fd = new FormData(form), n = Math.max(1, parseInt(fd.get('quantity'), 10) || 1);
    var line = { id: +fd.get('id'), quantity: n }; var sp = fd.get('selling_plan'); if (sp) line.selling_plan = +sp;
    var mt = inner() && inner().querySelector('[data-mt]');
    var has = !!((inner() && inner().dataset.mkeys) || (mt && mt.classList.contains('is-locked')));
    var items = [line];
    if (!has && root.dataset.mv) { var mi = { id: +root.dataset.mv, quantity: 1, properties: { Promo: root.dataset.freeMonth === 'true' ? '2 months free membership' : 'First month free' } }; if (+root.dataset.plan) mi.selling_plan = +root.dataset.plan; items.push(mi); }
    var btn = form.querySelector('[data-add]'), old = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…'; }
    var title = (root.querySelector('.pdp-title') || {}).textContent || 'Item';
    msg('<span class="cd__spin" aria-hidden="true"></span> Adding to your cart…', ''); wrap.classList.add('is-busy'); open();
    enqueue(function () {
      return postJson('/cart/add.js', { items: items, sections: sectionsParam() }).then(function (j) {
        return apply(j.sections).catch(function () { return refresh().catch(function () {}); }).then(function () {
          msg('<span class="cd__tick" aria-hidden="true">✓</span> Added ' + (n > 1 ? n + ' × ' : '') + esc(title.trim()) + (has ? '' : ' with membership'), 'ok');
          enqueue(function () { return postJson('/cart/update.js', { discount: root.dataset.code || 'NEWMEMBER', sections: sectionsParam() }).then(function (j2) { return apply(j2.sections); }).catch(function () {}); });
        });
      });
    }).catch(function (err) { msg(esc(err.message || 'Sorry, that could not be added.'), 'error'); })
      .then(function () {
        wrap.classList.remove('is-busy');
        if (btn) { btn.classList.remove('is-loading'); btn.innerHTML = old; btn.disabled = false; }
        tog.dispatchEvent(new Event('change', { bubbles: true })); /* let pdp.js repaint the button state */
      });
  }, true);

  /* ---------- "Join" buttons (membership page, footer offer, anywhere linking to the membership product): add the
     monthly membership straight to the cart and open the drawer instead of going to the product page ---------- */
  var joining = false;
  /* v39: true during a "first 2 months free" window (assets/aw-offer.js) */
  function free2() { return !!(window.AWOffer && window.AWOffer.active && window.AWOffer.active()); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="/products/membership"], [data-mem-join], a.fo__btn--red[href*="/pages/membership"]');
    if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var C = window.CW || {}, mv = +C.mv || +((a.getAttribute('href') || '').split('variant=')[1] || 0);
    if (!mv) return;
    e.preventDefault();
    if (C.member) { openNow(); return; }
    if (joining) return; joining = true;
    msg('<span class="cd__spin" aria-hidden="true"></span> Adding membership to your cart…', ''); open();
    enqueue(function () {
      return cartJson().then(function (cart) {
        if (membershipLines(cart).length) return refresh().then(function () { return 'had'; });
        var item = { id: mv, quantity: 1, properties: { Promo: free2() ? '2 months free membership' : 'First month free' } };
        if (+C.plan) item.selling_plan = +C.plan;
        return postJson('/cart/add.js', { items: [item], sections: sectionsParam() }).then(function (j) { return apply(j.sections); }).then(function () {
          enqueue(function () { return postJson('/cart/update.js', { discount: C.code || 'NEWMEMBER', sections: sectionsParam() }).then(function (j) { return apply(j.sections); }).catch(function () {}); });
        });
      });
    }).then(function (r) {
      msg('<span class="cd__tick" aria-hidden="true">✓</span> ' + (r === 'had' ? 'Membership is already in your cart.' : 'Membership added: ' + (free2() ? 'first 2 months free' : 'first month free') + ', then $' + (C.monthly || 27) + '/mo. Cancel anytime.'), 'ok');
    }).catch(function (err) {
      msg(esc(err.message || 'Sorry, the membership could not be added. Please try again.'), 'error');
    }).then(function () { joining = false; });
  }, true);

  window.CWCart = { open: openNow, refresh: refresh, apply: apply, enqueue: enqueue, msg: msg, show: open, busy: busy, sections: sectionsParam };

  /* Intercept every add-to-cart form on the site: one /cart/add.js that also returns the new drawer */
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.action || form.action.indexOf('/cart/add') === -1 || form.hasAttribute('data-no-drawer')) return;
    e.preventDefault();
    var btn = e.submitter || form.querySelector('[type="submit"]');
    var label = btn ? btn.innerHTML : '';
    if (btn) { btn.disabled = true; btn.classList.add('is-loading'); btn.textContent = 'Adding…'; }
    var stickyBtn = document.querySelector('[data-sb-add]');
    if (stickyBtn) stickyBtn.classList.add('is-loading');
    var fd = new FormData(form);
    fd.append('sections', sectionsParam());
    msg('<span class="cd__spin" aria-hidden="true"></span> Adding to your cart…', '');
    wrap.classList.add('is-busy'); open();
    enqueue(function () {
      return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { Accept: 'application/json' }, body: fd })
        .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
        .then(function (res) {
          if (!res.ok) { msg(esc(res.j.description || res.j.message || 'Sorry, that could not be added.'), 'error'); return; }
          return apply(res.j.sections).catch(function () { return refresh().catch(function () {}); }).then(function () {
            var qty = parseInt(fd.get('quantity'), 10) || 1;
            var name = res.j.product_title || 'Item';
            msg('<span class="cd__tick" aria-hidden="true">✓</span> Added ' + (qty > 1 ? qty + ' × ' : '') + esc(name), 'ok');
          });
        });
    })
      .catch(function () { form.setAttribute('data-no-drawer', ''); form.submit(); })
      .then(function () {
        wrap.classList.remove('is-busy');
        if (btn) { btn.disabled = false; btn.classList.remove('is-loading'); btn.innerHTML = label; }
        if (stickyBtn) stickyBtn.classList.remove('is-loading');
      });
  });
})();
